import fall25 from './fall25'
import spring25 from './spring25'
import spring26 from './spring26'
import spring27 from './spring27'
import fall27 from './fall27'

const state = {
  currentSite: 'fall27',
  previousSite: 'spring27'
}

const modules = {
  spring25,
  fall25,
  spring26,
  spring27,
  fall27
}

export default {
  state,
  modules,
  namespaced: true
}
